import React, { useEffect, useState } from "react";
import "antd/dist/antd.css";
import { Button, Row, Col, Modal, DatePicker, Divider, Switch } from "antd";
import { useTripsCtx } from "../../context/TripDetailsContext";
import styles from "../DashBoard/DashBoard.module.scss";
import textStyles from "../DashBoard/BookingSummary/BookingSummary.module.scss";
import groceryAvatar from "../../assets/icons/groceryAvatar.svg";
import rideAvatar from "../../assets/icons/rideAvatar.svg";
import cancelAvatar from "../../assets/icons/cancelAvatar.svg";
import { useDashboardCtx } from "../../context/DashboardContext";
import { RangeValue } from "rc-picker/lib/interface.d";
import {
  formatDateUtc,
  isPastDateRangeChanged,
  isUpcomingDateRangeChanged,
} from "../../helpers/tripHelper";
import moment, { Moment } from "moment";
import { swapRightOutlinedIcon } from "../../assets/images";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";
import {
  defaultFavoriteDateRange,
  defaultPastDateRange,
  defaultUpcomingDateRange,
} from "../../types/TripTypes";
import { getTripDetails } from "../ServiceUsers/ServiceUserData/ServiceUserData";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";

type DateRange = {
  startDate: string;
  endDate: string;
};

type PendingDateRanges = {
  upcoming: DateRange;
  past: DateRange;
  favorite: DateRange;
};

type Props = {
  isOpenFilter: boolean;
  setIsOpenFilter: Function;
  onUpcomingDateRangeChange: (newRange: DateRange) => void;
  onPastDateRangeChange: (newRange: DateRange) => void;
};
interface PendingSwitchesState {
  canceled: boolean;
  ride: boolean;
  grocery: boolean;
}
const DashBoardFilter: React.FC<Props> = ({
  isOpenFilter,
  setIsOpenFilter,
  onUpcomingDateRangeChange,
  onPastDateRangeChange,
}) => {
  const {
    serviceDataCtx,
    upcomingTripDetailsCtx,
    pastTripDetailsCtx,
    favoriteTripDetailsCtx,
  } = useTripsCtx();
  const {
    showCanceledCtx,
    activeTabCtx,
    pastDateRangeCtx,
    upcomingDateRangeCtx,
    favoriteDateRangeCtx,
    resetPagination,
    selectedPersonIdCtx,
    showDateRangeCtx,
  } = useDashboardCtx();
  const { caregiverSummaryInfo } = usePersonSummaryCtx();
  const [upcomingTripDetails, setUpcomingTripDetails] = upcomingTripDetailsCtx;
  const [pastTripDetails, setPastTripDetails] = pastTripDetailsCtx;
  const [favoriteTripDetails, setFavoriteTripDetails] = favoriteTripDetailsCtx;
  const [showDateRange, setShowDateRange] = showDateRangeCtx;
  const [showCanceled, setShowCanceled] = showCanceledCtx;
  const [activeTab, setActiveTab] = activeTabCtx;
  const [pastDateRange, setPastDateRange] = pastDateRangeCtx;
  const [upcomingDateRange, setUpcomingDateRange] = upcomingDateRangeCtx;
  const [favoriteDateRange, setFavoriteDateRange] = favoriteDateRangeCtx;
  const [selectedPersonId, setSelectedPersonId] = selectedPersonIdCtx;
  const [canceledSwitch, setCanceledSwitch] = useState<boolean>(false);
  const [rideSwitch, setRideSwitch] = useState<boolean>(false);
  const [grocerySwitch, setGrocerySwitch] = useState<boolean>(false);
  const [pendingSwitches, setPendingSwitches] = useState<PendingSwitchesState>({
    canceled: false,
    ride: true,
    grocery: false,
  });
  const [pendingDateRanges, setPendingDateRanges] = useState<{
    upcoming: DateRange;
    past: DateRange;
    favorite: DateRange;
  }>({
    upcoming: upcomingDateRange,
    past: pastDateRange,
    favorite: favoriteDateRange,
  });
  const { RangePicker } = DatePicker;

  useEffect(() => {
    if (!pendingSwitches.ride) {
      setPendingSwitches((prevState) => ({
        ...prevState,
        ride: true,
      }));
    }
  }, [activeTab]);

  const handleApplyFilters = () => {
    setIsOpenFilter(false);

    if (pendingSwitches.canceled !== showCanceled) {
      setShowCanceled(pendingSwitches.canceled);
    }

    if (
      pendingDateRanges.upcoming.startDate !== upcomingDateRange.startDate ||
      pendingDateRanges.upcoming.endDate !== upcomingDateRange.endDate
    ) {
      setUpcomingDateRange(pendingDateRanges.upcoming);
      onUpcomingDateRangeChange(pendingDateRanges.upcoming);
    }

    if (
      pendingDateRanges.past.startDate !== pastDateRange.startDate ||
      pendingDateRanges.past.endDate !== pastDateRange.endDate
    ) {
      setPastDateRange(pendingDateRanges.past);
      onPastDateRangeChange(pendingDateRanges.past);
    }

    if (
      pendingDateRanges.favorite.startDate !== favoriteDateRange.startDate ||
      pendingDateRanges.favorite.endDate !== favoriteDateRange.endDate
    ) {
      setFavoriteDateRange(pendingDateRanges.favorite);
    }

    //for 05.02 filter changes
    // if (pendingSwitches.ride !== rideSwitch) {
    //   if (!pendingSwitches.ride) {
    //     if (activeTab === "1") {
    //       setUpcomingTripDetails([]);
    //     } else if (activeTab === "2") {
    //       setPastTripDetails([]);
    //     } else {
    //       setFavoriteTripDetails([]);
    //     }
    //   } else {
    //     if (activeTab === "1") {
    //       setUpcomingDateRange(defaultUpcomingDateRange);
    //     } else if (activeTab === "2") {
    //       setPastDateRange(defaultPastDateRange);
    //     } else {
    //       setFavoriteDateRange(defaultFavoriteDateRange);
    //     }
    //   }
    //   setRideSwitch(false);
    // }

    setCanceledSwitch(false);
  };

  const handleGrocerySwitchChange = (checked: boolean) => {
    setPendingSwitches((prevState) => ({
      ...prevState,
      grocery: checked,
    }));
  };

  const handleRideSwitchChange = () => {
    if (!pendingSwitches.ride) {
      setPendingSwitches((prevState) => ({
        ...prevState,
        ride: true,
      }));
    } else {
      setPendingSwitches((prevState) => ({
        ...prevState,
        ride: false,
      }));
    }
    setRideSwitch(true);
  };

  const handleCanceledSwitchChange = (checked: boolean) => {
    if (!pendingSwitches.canceled) {
      setPendingSwitches((prevState) => ({
        ...prevState,
        canceled: true,
      }));
    } else {
      setPendingSwitches((prevState) => ({
        ...prevState,
        canceled: false,
      }));
    }
    setCanceledSwitch(true);
  };

  const handleFilterDateRangeChange = (
    dates: RangeValue<Moment>,
    dateStrings: string[]
  ) => {
    if (activeTab === "1") {
      setPendingDateRanges((prevState) => ({
        ...prevState,
        upcoming: {
          startDate: dates ? dateStrings[0] : "",
          endDate: dates ? dateStrings[1] : "",
        },
      }));
    } else if (activeTab === "2") {
      setPendingDateRanges((prevState) => ({
        ...prevState,
        past: {
          startDate: dates ? dateStrings[0] : "",
          endDate: dates ? dateStrings[1] : "",
        },
      }));
    } else if (activeTab === "3") {
      setPendingDateRanges((prevState) => ({
        ...prevState,
        favorite: {
          startDate: dates ? dateStrings[0] : "",
          endDate: dates ? dateStrings[1] : "",
        },
      }));
    }

    setShowDateRange({
      startDate: dates ? dateStrings[0] : "",
      endDate: dates ? dateStrings[1] : "",
    });
  };

  const handleResetDateRange = () => {
    if (activeTab === "1") {
      setPendingDateRanges((prevState: PendingDateRanges) => ({
        ...prevState,
        upcoming: defaultUpcomingDateRange(),
      }));
    } else if (activeTab === "2") {
      setPendingDateRanges((prevState: PendingDateRanges) => ({
        ...prevState,
        past: defaultPastDateRange(),
      }));
    } else {
      setPendingDateRanges((prevState: PendingDateRanges) => ({
        ...prevState,
        favorite: defaultFavoriteDateRange(),
      }));
    }
  };

  const handleReset = () => {
    if (
      pendingDateRanges.upcoming.startDate !== upcomingDateRange.startDate ||
      pendingDateRanges.upcoming.endDate !== upcomingDateRange.endDate
    ) {
      setPendingDateRanges((prevState) => ({
        ...prevState,
        upcoming: upcomingDateRange,
      }));
    }

    if (
      pendingDateRanges.past.startDate !== pastDateRange.startDate ||
      pendingDateRanges.past.endDate !== pastDateRange.endDate
    ) {
      setPendingDateRanges((prevState) => ({
        ...prevState,
        past: pastDateRange,
      }));
    }

    if (
      pendingDateRanges.favorite.startDate !== favoriteDateRange.startDate ||
      pendingDateRanges.favorite.endDate !== favoriteDateRange.endDate
    ) {
      setPendingDateRanges((prevState) => ({
        ...prevState,
        favorite: favoriteDateRange,
      }));
    }

    if (pendingSwitches.canceled !== showCanceled && canceledSwitch) {
      setPendingSwitches((prevState) => ({
        ...prevState,
        canceled: !pendingSwitches.canceled,
      }));
    }
    setCanceledSwitch(false);
    setIsOpenFilter(false);
  };

  return (
    <>
      <Modal
        visible={isOpenFilter}
        width={375}
        centered
        className={styles.filterModal}
        footer={
          <Row
            justify="center"
            gutter={[10, 10]}
            className={styles.modalFilterFooterMargin}
          >
            <Col>
              <Button className={styles.resetFilters} onClick={handleReset}>
                Cancel
              </Button>
            </Col>
            <Col>
              <Button
                className={styles.applyFilterBtn}
                onClick={handleApplyFilters}
              >
                Apply
              </Button>
            </Col>
          </Row>
        }
      >
        <Row className={styles.filterBodyContainer}>
          <Row
            className={`${textStyles.normalText14} ${styles.dateHeadingContainer}`}
            gutter={[0, 16]}
          >
            Date <Col span={24} />
          </Row>
          <Row className={styles.filterRangePickerContainer}>
            <Col className={styles.filterRangePicker}>
              <RangePicker
                format="MM/DD/YYYY"
                value={[
                  moment(
                    formatDateUtc(
                      activeTab === "1"
                        ? pendingDateRanges.upcoming.startDate
                        : activeTab === "2"
                          ? pendingDateRanges.past.startDate
                          : pendingDateRanges.favorite.startDate
                    )
                  ).isValid()
                    ? moment(
                      formatDateUtc(
                        activeTab === "1"
                          ? pendingDateRanges.upcoming.startDate
                          : activeTab === "2"
                            ? pendingDateRanges.past.startDate
                            : pendingDateRanges.favorite.startDate
                      )
                    )
                    : null,
                  moment(
                    formatDateUtc(
                      activeTab === "1"
                        ? pendingDateRanges.upcoming.endDate
                        : activeTab === "2"
                          ? pendingDateRanges.past.endDate
                          : pendingDateRanges.favorite.endDate
                    )
                  ).isValid()
                    ? moment(
                      formatDateUtc(
                        activeTab === "1"
                          ? pendingDateRanges.upcoming.endDate
                          : activeTab === "2"
                            ? pendingDateRanges.past.endDate
                            : pendingDateRanges.favorite.endDate
                      )
                    )
                    : null,
                ]}
                onChange={handleFilterDateRangeChange}
                allowClear={false}
                separator={
                  <img
                    src={swapRightOutlinedIcon}
                    alt="swap-RightOutlined-Icon"
                  />
                }
              />
            </Col>
          </Row>
          <Row
            className={`${textStyles.normalText14} ${styles.resetCalanderBtn}`}
            gutter={[0, 16]}
          >
            <Button
              onClick={handleResetDateRange}
              className={`${styles.dataResetBtnStyle} ${styles.normalText14}`}
            >
              Today {activeTab == 1 ? "+" : "-"}30 days
            </Button>

            <Col span={24} />
          </Row>
          {activeTab === "2" && (
            <>
              <Divider className={styles.solidDivider} />

              <Row
                className={`${styles.showHideTextStyle} ${textStyles.normalText14}`}
              >
                <Col>Turn on/off to show/hide service</Col>
              </Row>
              {activeTab === "3" && (
                <>
                  <Row className={styles.carSwitchContainer}>
                    <Col>
                      <img src={rideAvatar} alt="ride-Icon" />
                    </Col>{" "}
                    <Col className={styles.tripSwitchIcon}>
                      {" "}
                      <Switch
                        checked={pendingSwitches.ride}
                        onChange={handleRideSwitchChange}
                      />
                      <span
                        className={`${styles.switchTextStyle} ${textStyles.normalText14}`}
                      >
                        Rides: {pendingSwitches.ride ? "show" : "hide"}
                      </span>
                    </Col>
                  </Row>
                  <Row className={styles.shoppingSwitchContainer}>
                    <Col>
                      <img src={groceryAvatar} alt="grocery-Icon" />
                    </Col>{" "}
                    <Col className={styles.tripSwitchIcon}>
                      {" "}
                      <Switch
                        defaultChecked
                        onChange={handleGrocerySwitchChange}
                      />
                      <span
                        className={`${styles.switchTextStyle} ${textStyles.normalText14}`}
                      >
                        Grocery: {pendingSwitches.grocery ? "show" : "hide"}
                      </span>
                    </Col>
                  </Row>
                </>
              )}

              <Row className={styles.shoppingSwitchContainer}>
                <Col>
                  <img
                    className={styles.cancelIconStyle}
                    src={cancelAvatar}
                    alt="cancel-Icon"
                  />
                </Col>{" "}
                <Col className={styles.tripSwitchIcon}>
                  {" "}
                  <Switch
                    checked={pendingSwitches.canceled}
                    onChange={handleCanceledSwitchChange}
                  />{" "}
                  <span
                    className={`${styles.switchTextStyle} ${textStyles.normalText14}`}
                  >
                    Canceled: {pendingSwitches.canceled ? "show" : "hide"}
                  </span>
                </Col>
              </Row>
            </>
          )}
        </Row>
      </Modal>
    </>
  );
};

export default DashBoardFilter;
